import { useEffect } from 'react';

import Button from 'components/ui-kit/buttons/button';
import RequestWorkModal from 'components/request-work-modal';
import { forgetDepositReturn, readDepositReturn } from 'components/request-work-modal/deposit';

import { useApp, useModal } from 'hooks';

import * as S from './styles';

const RequestWork = () => {
  const { portal, isPreviewMode } = useApp();
  const { showModal } = useModal();
  const clickHandler = isPreviewMode ? () => {} : () => showModal(RequestWorkModal);

  // A customer back from the payment page sees how the payment stands, whichever page the portal opened on.
  useEffect(() => {
    const depositReturn = !isPreviewMode && portal ? readDepositReturn(portal.id) : null;

    // However it is closed (the X and Esc as well as "Got it!"), it is not shown again on a reload.
    if (depositReturn) {
      showModal(RequestWorkModal, { depositReturn }, { onHide: () => forgetDepositReturn(portal.id) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portal?.id]);

  if (!portal) {
    return <S.InfoBox />;
  }

  return (
    <S.InfoBox>
      <S.ImageContainer>
        <S.BookIcon />
      </S.ImageContainer>

      <S.Text>
        Quickly book
        <br />
        service online
      </S.Text>

      <Button onClick={clickHandler} color="primary">
        Book Online
      </Button>
    </S.InfoBox>
  );
};

export default RequestWork;
